export enum NEOCardValidity {
    MONTHS = 36,
}
